export enum KeysEnum {
  UserId = 'userId',
  WorkflowId = 'workflowId',
  InvoiceId = 'invoiceId',
  TransactionType = 'transactionType',
  Page = 'page',
  PageCantReset = 'pageCantReset',
  SourceLanguage = 'sourceLanguage',
  SourceLanguageCode = 'sourceLanguageCode',
  TargetLanguages = 'targetLanguages',
  TargetLanguagesCode = 'targetLanguagesCode',
  Keys = 'keys',
  Type = 'type',
  Ids = 'ids',
  Id = 'id',
  Index = 'index',
  EditorId = 'editorId',
  PoCode = 'poCode',
  Query = 'query',
  DateRange = 'dateRange',
  DatePreferred = 'datePreferred',
  Quality = 'quality',
  ShowDuplicates = 'showDuplicates',
  TranslatedByAgent = 'translatedByAgent',
  TranslationRequestVersion = 'translationRequestVersion',
  TranslationRequestId = 'translationRequestId',
  TaskId = 'taskId',
  RedirectTo = 'redirectTo',
  Token = 'token',
  Email = 'email',
  Password = 'password',
  Languages = 'languages',
  Code = 'code',
  Language = 'language',
  Title = 'title',
  Topic = 'topic',
  ContentLength = 'contentLength',
  AdditionalInstructions = 'additionalInstructions',
  ContentType = 'contentType',
  ContentFormat = 'contentFormat',
  Quote = 'quote',
  SortAttribute = 'sortAttribute',
  SortOrder = 'sortOrder',
  TagId = 'tagId',
  LanguagePair = 'languagePair',
  Comments = 'comments',
  StyleGuides = 'styleGuides',
  StyleGuideId = 'styleGuideId',
  StyleGuide = 'styleGuide',
  ContextIds = 'contextIds',
  Details = 'details',
  Integrations = 'integrations',
  Logs = 'logs',
  ContentBrief = 'contentBrief',
  Callback = 'callback',
  Status = 'status',
  Search = 'search',
  Replace = 'replace',
  Filters = 'filters',
  Content = 'content'
}
